// // import React, { useEffect, useState, useCallback, Fragment } from 'react';
// // import { connect } from 'react-redux';
// // import { useNavigate } from 'react-router-dom';
// // import {
// //   LocalService,
// //   SubscriptionService,
// // } from '../../core/services';
// // // For subscription payment
// // // import useRazorpay from 'react-razorpay';
// // import { SubscriptionDetail } from '../../redux/action';
// // import { makeRazorpayPayment } from "../../core/services/PaymentService";
// // // To render common pricing plan compoent
// // import PricingPlan from '../common/settings/subscription/pricing-plan';
// // // To render basic plan data
// // import { SubscriptionBasicPlanData } from '../common/settings/subscription/subscription-plan-data';
// // import * as gtUtil from '../../core/utility';

// // // const localService: LocalService = new LocalService();
// // const subscriptionService: SubscriptionService = new SubscriptionService();

// // interface Props {
// //   UserReducer: any;
// //   SubscriptionDetail: (data: any) => void;
// // }

// // export const MobileSubscription: React.FC<Props> = (props: Props) => {
// //   // const [razorpay] = useRazorpay();
// //   const [availablePlan, setAvailablePlan] = useState<any>(null);
// //   const [activePlan, setActivePlan] = useState<any>(null);
// //   const [loading, setLoading] = useState(false);
// //   const [planType, setPlanType] = useState('');
// //   const navigate = useNavigate();


// //   // To fetch the basic plan details
// //   const basicPlan: any = ['Influencer', 'Talent Partner'].includes(props?.UserReducer?.account_type) ? SubscriptionBasicPlanData.influencer : SubscriptionBasicPlanData.brand

// //   const handlePlanType = (tab: string) => {
// //     setPlanType(tab);
// //   }

// //   const getSubscriptionDetail = useCallback(() => {
// //     //get Subscription Plan Detail
// //     const { user_id, account_id, account_type, influencer_id } = props.UserReducer;
// //     async function getSubs() {
// //       try {
// //         const response = await subscriptionService.getPlanDetails({
// //           user_id: user_id,
// //           account_id: account_id,
// //           user_type: account_type,
// //           influencer_id: influencer_id,
// //         });
// //         if (response.status === gtUtil.Constants.SUCCESS) {
// //           //return Only Active Plan Info
// //           setAvailablePlan(response.data.rows);
// //           setPlanType(response.data.rows[0].plan_type);
// //         } else {
// //           // localService.toastify(response.data.status.message, 'info', 1000);
// //           setAvailablePlan(null);
// //         }

// //         //update subscription Details
// //         const getPlanDetails: any =
// //           await subscriptionService.getSubscription_Remaining_Days({
// //             account_id: props.UserReducer.account_id,
// //             user_id: props.UserReducer.user_id,
// //             influencer_id: props.UserReducer.influencer_id
// //           });

// //         if (getPlanDetails.status === gtUtil.Constants.SUCCESS) {
// //           props.SubscriptionDetail(getPlanDetails.data.rows[0]);
// //         }
// //       } catch (error) {
// //         throw new Error(
// //           `getSubsctiption Detail in Subscription Influencer :: ${JSON.stringify(
// //             error
// //           )}`
// //         );
// //       }
// //     }

// //     async function getActivePlan() {
// //       try {
// //         const response: any =
// //           await subscriptionService.getSubscription_Remaining_Days({
// //             user_id: user_id,
// //             account_id: account_id,
// //             influencer_id: influencer_id
// //           });
// //         if (response.status === gtUtil.Constants.SUCCESS) {
// //           setActivePlan(response.data.rows[0]);
// //         } else {
// //           setActivePlan(null);
// //         }
// //       } catch (error) {
// //         console.log(
// //           `getActivePlan error in influencer Section :: ${JSON.stringify(
// //             error
// //           )}`
// //         );
// //       }
// //     }
// //     getActivePlan();
// //     getSubs();
// //   }, [props.UserReducer]);

// //   useEffect(() => {
// //     getSubscriptionDetail();
// //   }, [getSubscriptionDetail]);

// //   // For subscription payment
// //   const makePayment = async (data: any) => {
// //     // Your makePayment function logic here
// //     setLoading(true);
// //     try {
// //       // const paymentResponse = await makeRazorpayPayment(data, props, razorpay);
// //       const paymentResponse = await makeRazorpayPayment(data, props);
// //       if (paymentResponse?.status) {
// //         // Payment successful, perform necessary actions
// //         if (['Brand', 'Agency'].includes(props.UserReducer?.account_type)) {
// //           navigate(`/brand/orders/confirmed?payment_id=${paymentResponse?.paymentId}`);
// //         } else {
// //           navigate(`/influencer/orders/confirmed?payment_id=${paymentResponse?.paymentId}`);
// //         }
// //       } else {
// //         // Payment failed, handle it
// //         console.log("Payment failed");
// //         // localService.toastify(paymentResponse?.message, "error", 1000);
// //       }
// //     } catch (error) {
// //       console.error(`Make Payment Error :: ${JSON.stringify(error)}`);
// //     } finally {
// //       setLoading(false);
// //     }
// //   }

// //   return (
// //     <Fragment>
// //       <div className='list-section-content rounded'>
// //         <div className='row align-items-center'>
// //           <strong className='col'>Subscription</strong>
// //           {props.UserReducer.agency_account_id && props.UserReducer.brand_id && (
// //             <span>On Behalf of Brand: <strong>{props.UserReducer.brand_name}</strong></span>
// //           )}
// //           {props.UserReducer.account_type === 'Talent Partner' && props.UserReducer.influencer_type === 'Talent Partner' && (
// //             <span>On Behalf of Influencer: <strong>{props.UserReducer.name}</strong></span>
// //           )}
// //         </div>
// //       </div>
// //       <main className='full-width pb-3 page-pricing'>
// //         <div className='pricing-tab p-0'>
// //           {
// //             planType && planType === 'Half-Yearly' && 
// //             <span>
// //               📢 Important Update: Our <strong>half-yearly</strong> subscription plan will be discontinued from <strong>1st November, 2024</strong>. Grab it before it's gone!
// //             </span>
// //           }
// //           <span className={`plan-switch-btns mt-4 ${props.UserReducer.account_type === 'Influencer' ? "d-none": ""}`}>
// //             <div className='sidebar-nav mb-0'>
// //               {availablePlan && availablePlan.map((plan: any) =>
// //                 <span className={` sidebar-nav-link sml ${planType === plan.plan_type ? 'active' : ''}`} onClick={() => handlePlanType(plan.plan_type)}>{plan.plan_type}</span>
// //               )}
// //             </div>
// //           </span>
// //           <div className='tab-content' id='pricingTabContent'>
// //             <div className='pricing-sec-infl'>
// //               <div className='pricing-sec-right'>
// //                 <div className='pricing-plan-sec'>
// //                   {
// //                     (basicPlan && props.UserReducer.account_type !=="Influencer") &&
// //                     (
// //                       <PricingPlan
// //                         key={basicPlan.id}
// //                         subscription_plan={basicPlan}
// //                         account_type={props.UserReducer.account_type}
// //                       />
// //                     )
// //                   }
// //                   {
// //                     availablePlan &&
// //                     (
// //                       <Fragment>
// //                         {availablePlan.map((data: any, index: number) => {
// //                           if (planType === data.plan_type) {
// //                             return (
// //                               <PricingPlan
// //                                 key={data.id}
// //                                 subscription_plan={data}
// //                                 makePayment={makePayment} // Pass makePayment function as prop
// //                                 loading={loading} // Pass loading state as prop
// //                                 account_type={props.UserReducer.account_type}
// //                                 activePlan={activePlan}
// //                               />
// //                             );
// //                           }
// //                           return null;
// //                         })}
// //                       </Fragment>
// //                     )
// //                   }
                  
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </main>
// //     </Fragment>
// //   );
// // };


// import React, { useEffect, useState, useCallback, Fragment } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   SubscriptionService,
// } from '../../core/services';
// import { makeRazorpayPayment } from "../../core/services/PaymentService";
// import PricingPlan from '../common/settings/subscription/pricing-plan';
// import { SubscriptionBasicPlanData } from '../common/settings/subscription/subscription-plan-data';
// import * as gtUtil from '../../core/utility';
// import { UserService } from "../../core/services";
import { AddonCheckout, AddonCheckoutMessage } from './addon-checkout';

// const subscriptionService: SubscriptionService = new SubscriptionService();
// const userService = new UserService();

// export const MobileSubscription: React.FC = () => {
//   const [availablePlan, setAvailablePlan] = useState<any>(null);
//   const [activePlan, setActivePlan] = useState<any>(null);
//   const [loading, setLoading] = useState(false);
//   const [planType, setPlanType] = useState('');
//   const navigate = useNavigate();

//   // 🔧 Mock user data (replacing props.UserReducer)
//   const user = {
//     user_id: 75673,
//     account_id: 75111,
//     account_type: 'Influencer',
//     influencer_id: 93950,
//     agency_account_id: null,
//     brand_id: null,
//     brand_name: null,
//     name: 'shobhit chauhan',
//     influencer_type: 'Individual',
//     account_name: 'shobhit chauhan',
//   };

//   // 🔧 Mock SubscriptionDetail dispatcher
//   const SubscriptionDetail = (data: any) => {
//     console.log('Subscription detail updated:', data);
//   };

//   // To fetch the basic plan details
//   const basicPlan: any = ['Influencer', 'Talent Partner'].includes(user.account_type)
//     ? SubscriptionBasicPlanData.influencer
//     : SubscriptionBasicPlanData.brand;

//   const handlePlanType = (tab: string) => {
//     setPlanType(tab);
//   };

//   const getSubscriptionDetail = useCallback(() => {
//     async function getSubs() {
//       try {
//         const response = await subscriptionService.getPlanDetails({
//           user_id: user.user_id,
//           account_id: user.account_id,
//           user_type: user.account_type,
//           influencer_id: user.influencer_id,
//         });

//         if (response.status === gtUtil.Constants.SUCCESS) {
//           setAvailablePlan(response.data.rows);
//           setPlanType(response.data.rows[0].plan_type);
//         } else {
//           setAvailablePlan(null);
//         }

//         const getPlanDetails = await subscriptionService.getSubscription_Remaining_Days({
//           account_id: user.account_id,
//           user_id: user.user_id,
//           influencer_id: user.influencer_id,
//         });

//         if (getPlanDetails.status === gtUtil.Constants.SUCCESS) {
//           SubscriptionDetail(getPlanDetails.data.rows[0]);
//         }
//       } catch (error) {
//         throw new Error(`getSubscriptionDetail error: ${JSON.stringify(error)}`);
//       }
//     }

//     async function getActivePlan() {
//       try {
//         const response = await subscriptionService.getSubscription_Remaining_Days({
//           user_id: user.user_id,
//           account_id: user.account_id,
//           influencer_id: user.influencer_id,
//         });

//         if (response.status === gtUtil.Constants.SUCCESS) {
//           setActivePlan(response.data.rows[0]);
//         } else {
//           setActivePlan(null);
//         }
//       } catch (error) {
//         console.log(`getActivePlan error: ${JSON.stringify(error)}`);
//       }
//     }

//     getActivePlan();
//     getSubs();
//   }, []);

//   useEffect(() => {
//     getSubscriptionDetail();

//    (async () => {
//          // Extract the key from the URL query string
//          const searchParams = new URLSearchParams(window.location.search);
//          const key = searchParams.get("key");
   
//          if (!key) {
//            console.error("No key found in URL");
//           //  navigate("/login");
//          }
   
//          try {

//           const getSubscriptionUserDetails = await userService.getSubscriptionUserDetails({key});

//           if( getSubscriptionUserDetails.status == gtUtil.Constants.SUCCESS ) {
            
//           }

//           console.log("getSubscriptionUserDetails response:", getSubscriptionUserDetails);  

//           //  // Call the updateUrlHitCount API to increment the count
//           //  const updateRes = await userService.updateUrlHitCount({ key });
   
//           //  if (updateRes.status == gtUtil.Constants.SUCCESS) {
//           //    // If the update is successful, define a function to call checkKeyValidation
//           //    const checkKeyValidation = async () => {
//           //      try {
//           //        const validationRes = await userService.checkKeyValidation({
//           //          key,
//           //        });
//           //        if (validationRes.status === gtUtil.Constants.AUTH_ERROR) {
//           //          //navigate to invalid page
//           //         //  navigate(`/request-status?key=${key}`);
//           //        } else {
//           //         console.log("Validation response:", validationRes);
//           //         //  setRemainingSeconds(validationRes.data.remaining_seconds);
//           //         //  setPurpose(validationRes.data.purpose);
//           //          if (validationRes.data.remaining_seconds <= 0) {
//           //           //  navigate(`/request-status?key=${key}`);
//           //          }
//           //         //  setLoader(false);
//           //        }
//           //      } catch (error) {
//           //        console.error("Validation API call error:", error);
//           //      }
//           //    };
   
//           //    // Call validation immediately
//           //    checkKeyValidation();
   
//           //    // Start polling every 5 seconds
//           //   //  intervalId = setInterval(checkKeyValidation, 5000);
//           //  } else {
//           //    //navigate to login page
//           //     console.log("Update response:", updateRes);
//           //    if (updateRes.status == gtUtil.Constants.AUTH_ERROR) {
//           //     //  navigate(`/request-status?key=${key}`);
//           //    } else {
//           //     //  navigate("/login");
//           //    }
//           //  }
//          } catch (error) {
//            console.error("updateUrlHitCount API call error:", error);
//          }
//        })();
//   }, [getSubscriptionDetail]);

//   const makePayment = async (data: any) => {
//     setLoading(true);
//     console.log("Payment data:", data);
//     try {
//       const paymentResponse = await makeRazorpayPayment(data, { UserReducer: user });
//       console.log("Payment response:", paymentResponse);
//       if (paymentResponse?.status) {
//         if (['Brand', 'Agency'].includes(user.account_type)) {
//           navigate(`/brand/orders/confirmed?payment_id=${paymentResponse?.paymentId}`);
//         } else {
//           navigate(`/influencer/orders/confirmed?payment_id=${paymentResponse?.paymentId}`);
//         }
//       } else {
//         console.log("Payment failed");
//       }
//     } catch (error) {
//       console.error(`Make Payment Error :: ${JSON.stringify(error)}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Fragment>
//       <div className='list-section-content rounded'>
//         <div className='row align-items-center'>
//           <strong className='col'>Subscription</strong>
//           {user.agency_account_id && user.brand_id && (
//             <span>On Behalf of Brand: <strong>{user.brand_name}</strong></span>
//           )}
//           {user.account_type === 'Talent Partner' && user.influencer_type === 'Talent Partner' && (
//             <span>On Behalf of Influencer: <strong>{user.name}</strong></span>
//           )}
//         </div>
//       </div>
//       <main className='full-width pb-3 page-pricing'>
//         <div className='pricing-tab p-0'>
//           {
//             planType === 'Half-Yearly' &&
//             <span>
//               📢 Important Update: Our <strong>half-yearly</strong> subscription plan will be discontinued from <strong>1st November, 2024</strong>. Grab it before it's gone!
//             </span>
//           }
//           <span className={`plan-switch-btns mt-4 ${user.account_type === 'Influencer' ? "d-none" : ""}`}>
//             <div className='sidebar-nav mb-0'>
//               {availablePlan && availablePlan.map((plan: any) =>
//                 <span className={`sidebar-nav-link sml ${planType === plan.plan_type ? 'active' : ''}`} onClick={() => handlePlanType(plan.plan_type)}>{plan.plan_type}</span>
//               )}
//             </div>
//           </span>
//           <div className='tab-content' id='pricingTabContent'>
//             <div className='pricing-sec-infl'>
//               <div className='pricing-sec-right'>
//                 <div className='pricing-plan-sec'>
//                   {
//                     (basicPlan && user.account_type !== "Influencer") &&
//                     (
//                       <PricingPlan
//                         key={basicPlan.id}
//                         subscription_plan={basicPlan}
//                         account_type={user.account_type}
//                       />
//                     )
//                   }
//                   {
//                     availablePlan && availablePlan.map((data: any) => (
//                       planType === data.plan_type && (
//                         <PricingPlan
//                           key={data.id}
//                           subscription_plan={data}
//                           makePayment={makePayment}
//                           loading={loading}
//                           account_type={user.account_type}
//                           activePlan={activePlan}
//                         />
//                       )
//                     ))
//                   }
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//     </Fragment>
//   );
// };


import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SubscriptionService,
} from '../../core/services';
import { makeRazorpayPayment, makeRazorpayAutoPay, makeBrandSubscriptionPayment, hasRazorpayPlan } from "../../core/services/PaymentService";
import * as gtUtil from '../../core/utility';
import { UserService } from "../../core/services";
import { PlanCheckout, PlanCheckoutLoading } from './plan-checkout';

const subscriptionService: SubscriptionService = new SubscriptionService();
const userService = new UserService();

export const MobileSubscription: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  // What the payment helpers get: the user, and this page's signed `?key=` (there
  // is no login token here) for the checkout's billing-state step.
  const paymentProps = { UserReducer: user, checkoutKey: new URLSearchParams(window.location.search).get('key') || '' };
  // null = loading.
  const [availablePlan, setAvailablePlan] = useState<any[] | null>(null);
  const [plansError, setPlansError] = useState('');
  const [activePlan, setActivePlan] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  // Brand app one-time purchase (signed key purpose 'brd_addon'): the one plan
  // the app asked for, nothing else. null = not loaded / unavailable.
  const [addonPlan, setAddonPlan] = useState<any>(null);
  const [addonError, setAddonError] = useState('');
  // The link's key couldn't be read (expired, already used up, or not valid).
  const [keyError, setKeyError] = useState('');
  const navigate = useNavigate();
  const isAddon = user?.checkout_purpose === 'brd_addon' && !!user?.checkout_addon_plan;

  const getSubscriptionDetail = useCallback(() => {
    if (!user) return;

    // One-time purchase: exactly the signed plan, for the signed platform (its
    // own price row). The plan name and platform come from the key.
    if (user.checkout_purpose === 'brd_addon' && user.checkout_addon_plan) {
      // The API sends the plan row with the key (/user/details), because this
      // page has no login and the plan-details endpoint below requires one
      // (a 401 there sent the brand to the login page).
      const signedRow = user.checkout_addon_plan_row;
      if (signedRow && signedRow.plan_name === user.checkout_addon_plan && Number(signedRow.plan_id) > 0) {
        setAddonPlan(signedRow);
        return;
      }
      // Older API without checkout_addon_plan_row.
      (async () => {
        try {
          const response: any = await subscriptionService.getFocCampaignPlanDetail({
            user_id: user.user_id,
            account_id: user.account_id,
            user_type: user.account_type,
            influencer_id: user.influencer_id,
            plan_name: user.checkout_addon_plan,
            platform: user.checkout_platform === 'android' || user.checkout_platform === 'ios' ? user.checkout_platform : undefined,
          });
          const row = response?.data?.rows?.[0];
          if (response?.data?.status?.status && row && row.plan_name === user.checkout_addon_plan) {
            setAddonPlan(row);
          } else {
            setAddonError("This purchase isn't available right now. Please go back to the app and try again.");
          }
        } catch (error) {
          setAddonError('Could not load this purchase. Please go back to the app and try again.');
        }
      })();
      return;
    }

    async function getSubs() {
      try {
        // This page is opened by the mobile apps (and is the ONLY way Android
        // can pay), so it must ask for that platform's plans. Without it the
        // backend defaults to 'web' and the user is both shown web pricing and
        // recorded as a web subscriber.
        //
        // The value comes from `user`, which was decoded from the SIGNED key —
        // NOT from the query string. An earlier version read ?platform= off the
        // URL, which let a visitor switch their own price tier by editing the
        // link (web ₹1,416 vs ios ₹1,499) and corrupt the attribution with it.
        const checkoutPlatform =
          user.checkout_platform === 'android' || user.checkout_platform === 'ios'
            ? user.checkout_platform
            : undefined;

        const response = await subscriptionService.getPlanDetails({
          user_id: user.user_id,
          account_id: user.account_id,
          user_type: user.account_type,
          influencer_id: user.influencer_id,
          ...(checkoutPlatform ? { platform: checkoutPlatform } : {}),
        });

        if (response?.status === gtUtil.Constants.SUCCESS && Array.isArray(response?.data?.rows)) {
          setAvailablePlan(response.data.rows);
        } else {
          setAvailablePlan([]);
        }
      } catch (error) {
        console.error(`getSubscriptionDetail error: ${JSON.stringify(error)}`);
        setPlansError('Could not load the plans. Please check your connection and reload this page.');
      }
    }

    async function getActivePlan() {
      try {
        const response = await subscriptionService.getSubscription_Remaining_Days({
          user_id: user.user_id,
          account_id: user.account_id,
          influencer_id: user.influencer_id,
        });

        if (response.status === gtUtil.Constants.SUCCESS) {
          setActivePlan(response.data.rows[0]);
        } else {
          setActivePlan(null);
        }
      } catch (error) {
        console.log(`getActivePlan error: ${JSON.stringify(error)}`);
      }
    }

    getActivePlan();
    getSubs();
  }, [user]);

  useEffect(() => {
    const fetchUserFromKey = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const key = searchParams.get("key");

      if (!key) {
        setKeyError('This payment link is not complete. Please go back to the app and tap Buy again.');
        return;
      }

      try {
        const getSubscriptionUserDetails = await userService.getSubscriptionUserDetails({ key });

        if (getSubscriptionUserDetails.status === gtUtil.Constants.SUCCESS) {
          setUser(getSubscriptionUserDetails.data);
        } else {
          setKeyError('This payment link has expired or is no longer valid. Please go back to the app and try again.');
        }
      } catch (error) {
        console.error("getSubscriptionUserDetails API call error:", error);
        setKeyError('Could not open this payment link. Please go back to the app and try again.');
      }
    };

    fetchUserFromKey();
  }, []);

  useEffect(() => {
    if (user) {
      getSubscriptionDetail();
    }
  }, [user, getSubscriptionDetail]);

  // One-time purchase: a Razorpay one-time order for the signed plan (the API
  // charges the plan's own amount), not linked to any campaign — the brand app
  // uses it as a credit when it publishes / unlocks.
  const payAddon = async () => {
    if (!user || !addonPlan || loading) return;
    setLoading(true);
    try {
      const paymentResponse: any = await makeRazorpayPayment(addonPlan, paymentProps);
      if (paymentResponse?.status) {
        const qp = new URLSearchParams();
        if (paymentResponse?.paymentId) qp.set('payment_id', paymentResponse.paymentId);
        navigate(`orders/confirmed?${qp.toString()}`);
      }
    } catch (error) {
      console.error(`Add-on payment error :: ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  // coupon_code (optional): when a special coupon is applied, the purchase goes
  // through the one-time discounted order and the backend recomputes the amount.
  const makePayment = async (data: any, coupon_code: string = '') => {
    if (!user || loading) return;

    setLoading(true);
    try {
      // Mirror the desktop journey (settings/subscription.tsx):
      //  - coupon        -> one-time discounted order (amount recomputed server-side)
      //  - Brand/Agency  -> Razorpay AUTOPAY (one-time brand plans are retired)
      //  - Influencer/TP -> Razorpay AUTOPAY (recurring) when the plan has a
      //                     Razorpay plan; else the one-time order, as this page
      //                     always did (never a failed autopay for a plan row
      //                     without one).
      let paymentResponse: any;
      if (coupon_code) {
        paymentResponse = await makeRazorpayPayment(data, paymentProps, coupon_code);
      } else if (['Brand', 'Agency'].includes(user.account_type)) {
        paymentResponse = await makeBrandSubscriptionPayment(data, paymentProps);
      } else if (hasRazorpayPlan(data)) {
        paymentResponse = await makeRazorpayAutoPay(data, paymentProps);
      } else {
        paymentResponse = await makeRazorpayPayment(data, paymentProps);
      }

      if (paymentResponse?.status) {
        // Carry whichever identifier we got (autopay -> razorpay_subscription_id,
        // one-time -> payment_id) so the confirmation page can fetch the order.
        const qp = new URLSearchParams();
        if (paymentResponse?.paymentId) qp.set('payment_id', paymentResponse.paymentId);
        if (paymentResponse?.razorpaySubscriptionId) qp.set('razorpay_subscription_id', paymentResponse.razorpaySubscriptionId);
        navigate(`orders/confirmed?${qp.toString()}`);
      }
    } catch (error) {
      console.error(`Make Payment Error :: ${JSON.stringify(error)}`);
    } finally {
      setLoading(false);
    }
  };

  if (!user) {
    return keyError ? <AddonCheckoutMessage title="Can't open this payment link" message={keyError} /> : <PlanCheckoutLoading />;
  }

  if (isAddon) {
    return (
      <AddonCheckout
        planName={user.checkout_addon_plan}
        brandName={user.brand_name}
        plan={addonPlan}
        error={addonError}
        loading={loading}
        onPay={payAddon}
      />
    );
  }

  return (
    <PlanCheckout
      user={user}
      plans={availablePlan}
      plansError={plansError}
      activePlan={activePlan}
      loading={loading}
      onPay={makePayment}
    />
  );
};
